module.exports = function ApplicationApplyToFunderController($scope){

  $scope.vm = this;
  
  var init = function() {
  }
 
  init();
}
